import {createFileRoute} from '@tanstack/react-router';

import {SettingsSearchParams} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ProjectSettings} from '~components/settings/ProjectSettings';
import {ProjectSettingsTabs} from '~components/settings/ProjectSettingsTab';

export const Route = createFileRoute('/settings/notifications')({
  validateSearch: SettingsSearchParams.validate,
  component: SettingsNotificationsPage,
});

function SettingsNotificationsPage(): JSX.Element {
  return (
    <BaseLayout>
      <ProjectSettings tabName={ProjectSettingsTabs.Notifications} />
    </BaseLayout>
  );
}
